<template>
    <div class="popup" v-cloak v-if="isShow" style="zIndex:200">
        <div class="content" id="licenseShow">
            <div class="title">
                {{$t('language.license.showTitle')}}
                <div class="icon white-close dialog-close" @click="isShow=false;"></div>
            </div>
            <div class="personInfo-content">
                <span style="">{{$t('language.license.showTip')}}</span>
                <strong>
                    {{licenseCode}}
                    <div class="copy-code" @click="copyCode()"></div>
                </strong>
                <el-button @click="isShow=false;">{{$t('language.common.ok')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'licenseShowPopup',
    props: ['subscrId'],
    data: function () {
        return {
            isShow: false,
        }
    },
    computed: {
        // 处理显示效果
        licenseCode() {
            let temp = this.subscrId.slice(2, 18).replace(/[^a-zA-Z0-9]/g, '').toUpperCase();// 仅保留16位以下的数字和字母，并且每4个字符加一个横杠
            return temp.replace(/(.{4})(?!$)/g, '$1 - ');// 每4个字符加一个横杠
        }
    },
    methods: {
        copyCode() {
            let oInput = document.createElement('input');
            oInput.value = this.subscrId.slice(2, 18).replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$toast({
                text: this.$t('language.twoStepverification.codeCopied'),
                type: 'success',
                idValue: "licenseShow",
            });
            oInput.remove()
        }
    }
}
</script>

<style scoped>
#licenseShow {
    width: 400px;/*no*/
    height: 230px;/*no*/
}

.personInfo-content {
    padding: 20px;/*no*/
    height: calc(100% - 40px);/*no*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    font-family: Arial;
    letter-spacing: 0em;
}

.personInfo-content span {
    font-family: Arial;
    font-size: 14px;
    cursor: context-menu;
    color: #3D3D3D;
}

.personInfo-content strong {
    flex: 1;
    font-family: Microsoft YaHei UI;
    font-size: 18px;/*no*/
    font-weight: bold;
    line-height: 22px;/*no*/
    letter-spacing: 0em;
    color: #333333;
    display: flex;
    align-items: center;
    position: relative;
}

.personInfo-content strong .copy-code {
    width: 16px;/*no*/
    height: 16px;/*no*/
    position: absolute;
    top: calc(50% - 8px);/*no*/
    right: -26px;/*no*/
    background: url("../../../assets/images/vectorImg/icon_copy_code.svg");
    cursor: pointer;
}

.personInfo-content .el-button {
    margin-top: 10px;/*no*/
    height: 30px;/*no*/
    min-width: 128px;/*no*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 30px;/*no*/
    gap: 6px 10px;/*no*/
    flex-wrap: wrap;
    align-content: center;
    border-radius: 4px;/*no*/
    background: #5562B4;
    color: #FFFFFF;
    font-size: 14px;
    font-family: Arial;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/license_show_popup.vue